import { useEffect, useState } from 'react';
import { usePageHeader } from '../../providers/PageHeaderProvider';
import { usePageTitle } from '../../hooks/usePageTitle';
import { OverviewContent } from '../../components/billing/overview/OverviewContent';

const RANGE_STORAGE_KEY = 'fv_billing_overviewRange';

export function OverviewDashboard() {
    usePageTitle('Billing overview');
    const { setTitle, setSubtitle } = usePageHeader();
    const [rangeLabel, setRangeLabel] = useState('');

    useEffect(() => {
        setTitle('Billing overview');
        setSubtitle(rangeLabel);
        return () => {
            setTitle(null);
            setSubtitle(null);
        };
    }, [rangeLabel, setTitle, setSubtitle]);

    return (
        <div className="h-full overflow-y-auto bg-gray-100">
            <div className="px-8 py-6">
                <OverviewContent
                    rangeStorageKey={RANGE_STORAGE_KEY}
                    onRangeLabelChange={setRangeLabel}
                />
            </div>
        </div>
    );
}
